import React, { useMemo, forwardRef } from 'react';
import { ViewProps } from 'react-native';
import { View, StyleSheet, ViewStyle } from 'react-native';

const styleFlex = {
    flexCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    flexRowCenter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    flexCol: {
        display: 'flex',
        flexDirection: 'column',
    },
    flexBtw: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    flexColBtw: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    flexColCenter: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    flexGrow: {
        flexGrow: 1,
    },
};
type Key = keyof typeof styleFlex;
export default forwardRef(function Flex(
    props: { flex?: Key | Key[]; style?: ViewStyle; className?: string | string[]; children: React.ReactNode } & ViewProps,
    ref: React.ForwardedRef<View>,
) {
    const { flex, children, ...rest } = props;
    const flexs = useMemo(() => (Array.isArray(flex) ? flex : [flex ?? 'flexRow']), [flex]);
    const styleList = useMemo(() => flexs.filter((v) => !!v).map((v) => styleFlex[v]), [flexs]);
    const style = useMemo(() => {
        return StyleSheet.create({
            default: Object.assign({}, ...styleList, props.style || {}),
        });
    }, [styleList, props.style]);
    return (
        <View {...rest} ref={ref} style={style.default}>
            {children}
        </View>
    );
});
